<script>
    export let windowHeight = 450, windowWidth=600;
    const screenRatio = 1.33;
    $:frameWidth = windowWidth * 0.8;
    $:frameHeight = Math.min(Math.max((windowWidth * 0.8 * screenRatio, 0), 450));
</script>
<style>
    .facebook-icon img{
        transition: transform .1s linear;
    }
    .facebook-icon img:hover{
        transform: rotate(-10deg);
    }
</style>
<div style="text-align: center">
    {#if windowWidth > 768}
        <div class="cursive-text" style="font-weight: 300; font-size: 1.2em">
            03 29 58 86 64
        </div>
        <div class="cursive-text" style="font-weight: 300; font-size: 1.2em">
            20 rue concorde Place du marché<br>
            88100 Saint-Dié-des-Vosges
        </div>
    {:else}
        <div class="cursive-text" style="font-weight: 300; font-size: 1.5em">
            03 29 58 86 64
        </div>
        <div class="cursive-text" style="font-weight: 300; font-size: 1.5em">
            20 rue concorde Place du marché<br>
            88100 Saint-Dié-des-Vosges
        </div>
    {/if}
    <div style="margin-top: 2em">
        <img alt="carte" src="/img/carte-vectorized.svg" style="width: {frameWidth}px; height: {frameHeight}px" />
<!--        <iframe title="GoogleMaps" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2654.8644516305617!2d6.948981315841735!3d48.28622354877481!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4793eea19d792703%3A0x9e75a657d49bacf!2sLe%20Croc%20Vosgien!5e0!3m2!1sfr!2sfr!4v1570359191337!5m2!1sfr!2sfr" width="{frameWidth}" height="{frameHeight}" frameborder="0" style="border:0;" allowfullscreen=""></iframe>-->
    </div>
    <div class="facebook-icon"  style="margin-top: 1em">
        <a href="https://www.facebook.com/crocvosgienV2/" target="_blank"><img alt="facebook" src="img/facebook_transparent.png"></a>
    </div>
    <div class="fb-page" data-href="https://www.facebook.com/crocvosgienV2" data-tabs="timeline" data-width="" data-height="" data-small-header="true" data-adapt-container-width="true" data-hide-cover="true" data-show-facepile="false"><blockquote cite="https://www.facebook.com/crocvosgienV2" class="fb-xfbml-parse-ignore"><a href="https://www.facebook.com/crocvosgienV2">Croc Vosgien</a></blockquote></div>

</div>